import "./js/directives";
import "./js/magics";
import "./js/toast";
import "./js/shopify";
import "./js/misc.js";

import Alpine from "alpinejs";
import anchor from "@alpinejs/anchor";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";
import clipboard from "@ryangjchandler/alpine-clipboard";

window.Alpine = Alpine;

Alpine.plugin(anchor);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(clipboard);
Alpine.start();

import Swiper from "swiper";
import {
  Pagination,
  Navigation,
  Controller,
  Thumbs,
  EffectFade,
  Autoplay,
} from "swiper/modules";

window.waitForElement = function (selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

window.Swiper = Swiper;
Swiper.use([Pagination, Navigation, Controller, Thumbs, EffectFade, Autoplay]);

window.dispatchEvent(new CustomEvent("swiper:init"));

window.dispatchEvent(new CustomEvent("base:ready"));
